import React from 'react';
import { Card, Col, Row } from 'antd';
import { isEmpty } from 'ramda';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router';
import styled from 'styled-components';
import { Account } from 'utils/apiClient/services/shorepay/types';

const StyledCard = styled(Card)`
  width: 100%;
  border-radius: 5px;
  .label {
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.45);
  }
  .value {
    font-size: 24px;
    font-weight: 50px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

interface StatsCardProps {
  label: React.ReactNode;
  value: string;
}
const StatsCard: React.FC<StatsCardProps> = ({ label, value }) => (
  <StyledCard bodyStyle={{ padding: '12px 18px' }}>
    <span className="label">{label}</span>
    <br />
    <span className="value">{value}</span>
  </StyledCard>
);

type Props = Pick<Account, 'balance' | 'last_payout'> & { currency: string };

const AccountOverviewStats: React.FC<Props> = ({
  currency,
  balance,
  last_payout,
}) => {
  const intl = useIntl();
  return (
    <Row gutter={25}>
      <Col md={8}>
        <StatsCard
          label={intl.formatMessage({ defaultMessage: 'Current Balance' })}
          value={intl.formatNumber(parseFloat(balance ?? '0'), {
            currency,
            style: 'currency',
          })}
        />
      </Col>

      <Col md={8}>
        {last_payout && !isEmpty(last_payout) ? (
          <StatsCard
            label={
              <>
                <FormattedMessage
                  defaultMessage="Last Payout from {date}"
                  values={{
                    date: intl.formatDate(last_payout.created),
                  }}
                />
                <Link to="/shorepay/reports?_=2" css="float: right">
                  <FormattedMessage defaultMessage="Details" />
                </Link>
              </>
            }
            value={intl.formatNumber(parseFloat(last_payout.amount), {
              currency,
              style: 'currency',
            })}
          />
        ) : (
          <StatsCard
            label={intl.formatMessage({ defaultMessage: 'Last Payout' })}
            value="-"
          />
        )}
      </Col>
    </Row>
  );
};

export default AccountOverviewStats;
